var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"invoice-status-column"},[_c('status-icon',{attrs:{"loading":_vm.loading,"icons":_vm.InvoiceStatusIcons,"status":_vm.status}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }